<template>
  <div class="min-h-300">
    <video
      :poster="media.placholder"
      class="object-cover"
      autoplay
      playsinline
      muted
      loop
      ref="video"
    >
      <source :src="media.video" type="video/mp4" />
    </video>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import playlistLight from '../assets/vid/loop1_light.mp4'
import playlistLightPlaceholder from '../assets/vid/loop1_light.jpg'
import playlistDark from '../assets/vid/loop1_dark.mp4'
import playlistDarkPlaceholder from '../assets/vid/loop1_dark.jpg'
import playlistWithNoteLight from '../assets/vid/loop2_light.mp4'
import playlistWithNoteLightPlaceholder from '../assets/vid/loop2_light.jpg'
import playlistWithNoteDark from '../assets/vid/loop2_dark.mp4'
import playlistWithNoteDarkPlaceholder from '../assets/vid/loop2_dark.jpg'
import speakerLight from '../assets/vid/loop3_light.mp4'
import speakerLightPlaceholder from '../assets/vid/loop3_light.jpg'
import speakerDark from '../assets/vid/loop3_dark.mp4'
import speakerDarkPlaceholder from '../assets/vid/loop3_dark.jpg'
import playlistWithNoteMovingLight from '../assets/vid/loop4_light.mp4'
import playlistWithNoteMovingLightPlaceholder from '../assets/vid/loop4_light.jpg'
import playlistWithNoteMovingDark from '../assets/vid/loop4_dark.mp4'
import playlistWithNoteMovingDarkPlaceholder from '../assets/vid/loop4_dark.jpg'

interface Media {
  video: string
  placholder: string
}

@Component({
})
export default class AnimationCard extends Vue {
  @Prop() id!: string
  @Getter themeIsDark!: boolean

  $refs!: {
    video: HTMLVideoElement
  }

  get media (): Media {
    return this.mediaMap[this.id][this.themeIsDark ? 'dark' : 'light']
  }

  get mediaMap (): { [k: string]: { dark: Media, light: Media } } {
    return {
      playlist: {
        dark: { video: playlistDark, placholder: playlistDarkPlaceholder },
        light: { video: playlistLight, placholder: playlistLightPlaceholder },
      },
      playlistWithNote: {
        dark: { video: playlistWithNoteDark, placholder: playlistWithNoteDarkPlaceholder },
        light: { video: playlistWithNoteLight, placholder: playlistWithNoteLightPlaceholder },
      },
      speaker: {
        dark: { video: speakerDark, placholder: speakerDarkPlaceholder },
        light: { video: speakerLight, placholder: speakerLightPlaceholder },
      },
      playlistWithNoteMoving: {
        dark: { video: playlistWithNoteMovingDark, placholder: playlistWithNoteMovingDarkPlaceholder },
        light: { video: playlistWithNoteMovingLight, placholder: playlistWithNoteMovingLightPlaceholder },
      },
    }
  }
}
</script>
